import { cloneElement, useContext } from 'react';
import { divIcon } from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { ThemeContext } from 'styled-components';

/**
 * react-leaflet's Marker component doesn't work when a React component is
 * supplied to it's `icon` prop, it needs static marker instead.  This hook
 * converts a component into the format the marker will function properly with
 *
 * @param {React.ReactElement} element Rendered React component
 * @param {object} divIconOptions Options for Leaflet's `divIcon` function
 * @returns {string}
 */
const useComponentAsLeafletIcon = (element, divIconOptions = {}) => {
  const theme = useContext(ThemeContext);

  return divIcon({
    // there's a known bug where ReactDOMServer breaks the styled-components
    // theme provider so the theme must be provided explicitly: https://stackoverflow.com/questions/56449604
    html: ReactDOMServer.renderToStaticMarkup(cloneElement(element, { theme })),
    // clear default leaflet class name to get rid of its default styling
    className: '',
    ...divIconOptions,
  });
};

export default useComponentAsLeafletIcon;
